import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Glide from '@glidejs/glide';
export default {
  name: 'ProductGlide',
  props: {
    index: {
      type: Number,
      default: 0
    },
    itemsLength: {
      type: Number,
      default: 0
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      slider: null
    };
  },
  computed: {
    hasSingleImage: function hasSingleImage() {
      return this.itemsLength < 2;
    }
  },
  watch: {
    index: function index(newValue) {
      if (newValue !== this.slider.index) {
        this.slider.enable();
        this.slider.go("=".concat(newValue));
      }
    },
    enabled: function enabled(value) {
      if (value) {
        this.slider.enable();
      } else {
        this.slider.disable();
      }
    }
  },
  mounted: function mounted() {
    this.initSlider();
  },
  beforeDestroy: function beforeDestroy() {
    this.slider.destroy();
    this.slider = null;
  },
  methods: {
    initSlider: function initSlider() {
      var _this = this;

      this.slider = new Glide(this.$refs.glideElement, {
        rewind: false
      }).mount();

      if (!this.enabled) {
        this.slider.disable();
      }

      this.slider.on('run.after', function () {
        if (_this.index !== _this.slider.index) {
          _this.$emit('update:index', _this.slider.index);
        }
      });
    },
    isCurrentDot: function isCurrentDot(currentDot) {
      return currentDot - 1 === this.index;
    }
  }
};